/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/

import Vue from "vue";

import MsButton from "@/components/button/MsButton.vue";
Vue.component(MsButton.name, MsButton);
import MsSplitButton from "@/components/button/MsSplitButton.vue";
Vue.component(MsSplitButton.name, MsSplitButton);
import MsInput from "@/components/input/MsInput.vue";
Vue.component(MsInput.name, MsInput);
import MsCheckbox from "@/components/checkbox/MsCheckbox.vue";
Vue.component(MsCheckbox.name, MsCheckbox);
import MsRadio from "@/components/radio/MsRadio.vue";
Vue.component(MsRadio.name, MsRadio);
import MsDatePicker from "@/components/datepicker/MsDatePicker.vue";
Vue.component(MsDatePicker.name, MsDatePicker);
import MsTextarea from '@/components/textarea/MsTextarea.vue';
Vue.component(MsTextarea.name, MsTextarea);
import VTooltip from '@/components/tooltip';
Vue.use(VTooltip);
import MsNumber from '@/components/number/MsNumber.vue';
Vue.component(MsNumber.name, MsNumber);
import MsComboBox from '@/components/combobox/MsCombobox.vue';
Vue.component(MsComboBox.name, MsComboBox);
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum.js';
Vue.component(MsComboboxEnum.name, MsComboboxEnum);


//phím tắt
import '@/components/shortkey/MsShortkey';